<template>
  <div id="sport">
    <div class="main">
      <div class="swiper">
        <swiper ref="mySwiper" :options="swiperOptions">
          <swiper-slide v-for="(item, index) in list" :key="index">
            <div class="item" @click="getToken(item,2)" :style="'background:url(' + lists[index%lists.length].icon + ') no-repeat;'">
              <!-- <div class="title">{{item.name}}</div> -->
              <img loading="lazy" class="nomal" v-lazy="item.imgUrl?item.imgUrl:defaultImg" @error="defImg()" />
              <div class="bottom">
                <!-- 进入游戏 -->
                <img loading="lazy" v-lazy="lists[index%lists.length].icon_b" alt="">
                <span>{{item.name}}</span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </div>
    </div>
    <!-- <ul>
      <li v-for="(item, index) in list" :key="index">
        <img loading="lazy" v-lazy="item.icon" alt="" />
        <div class="btn"></div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  name: "component_name",
  data() {
    return {
      swiperOptions: {
        // loop: true,
        slidesPerView: 4,
        // spaceBetween: 10,
        // autoplay: {
        //     disableOnInteraction: false,
        // },
        speed: 400,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
      },
      list:[],
      lists: [
        {
          icon:require('@/assets/images/mb/sport_bg1.png'),
          icon_b:require('@/assets/images/mb/sport-bottom1.png')
        },{
          icon:require('@/assets/images/mb/sport_bg2.png'),
          icon_b:require('@/assets/images/mb/sport-bottom2.png')
        },{
          icon:require('@/assets/images/mb/sport_bg3.png'),
          icon_b:require('@/assets/images/mb/sport-bottom3.png')
        },{
          icon:require('@/assets/images/mb/sport_bg4.png'),
          icon_b:require('@/assets/images/mb/sport-bottom4.png')
        },
      ],
      defaultImg:require('@/assets/images/mb/sports-default.png'),
    };
  },
  mounted(){
    this.getDataType();
  },
  methods:{
    // 获取数据列表
    getDataType(){
      let result = JSON.parse(localStorage.getItem('game_menus_pc'));
      this.list = result.data.ty;
    },
    // 进入游戏
    getToken: async function(req,index) {
    // return
        let self = this;
            var issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
            
        if (!self.$common.getUser()) {
            self.$message.warning('请登录')
            return
        }
        self.tenantId = self.$common.getUser().tenant_id
        self.username = self.$common.getUser().username
        self.uid = self.$common.getUser().user_id
        let datas = {
            tenantId: self.tenantId,
            username: self.username,
            gameId: index == 2?req.ids:req.id,
            clientIp: self.$config.clientIp,
            memberId: self.uid,
            terminalType: 1
        }
        self.$common.setGameRequestData(datas)
        
        const res = await self.$http.post(this.$api.getToken, datas, true)
        if (res.code == 0) {
            self.gameUrl = res.data;
            if (req.openMode === 1) {
            // if(issafariBrowser) {
                //  self.winOpen.location.href = self.gameUrl;
            // }else{
                window.open(self.gameUrl)
            // }
            
            }else{
                window.open(self.gameUrl)
            }

        } else {
            if (req.openMode === 1) {
            window.open('/error.html?type=1')
            // self.winOpen.location.href = '/error.html?type=1';
            }
            
            if (req.status === 0) {
            self.$message.error('维护中')
            }else{
            self.$message.error('进入游戏失败，请稍后重试！')
            }
        }
    },
    defImg(){
      let img = event.srcElement;
      img.src = this.defaultImg;
      img.onerror = null; //防止闪图
    },
  },
};
</script>

<style scoped lang="scss">
#sport {
  position: relative;
  width: 100%;
  min-width: 1200px;
  height: 872px;
  overflow: hidden;
  padding-bottom: 20px;
  // margin-bottom: -20px;
  background: url(../../static/image/pn/sportBg.jpg) no-repeat top;
  .main {
    height: 300px;
    margin: 550px auto 0;
    position: relative;
    overflow: hidden;
    // background: #050505;
    text-align: center;
    .swiper {
      background-color: #fff;
      width: 1200px;
      margin: 0 auto;
      position: relative;
    }
    .swiper-button-next, .swiper-container-rtl .swiper-button-prev{
      right: -50px;
      width: 20px;
      height: 20px;
      background-color: transparent;
      background-size: 20px 44px;
    }
    
    .swiper-button-prev, .swiper-container-rtl .swiper-button-next{
      left: -50px;
      width: 20px;
      height: 20px;
      background-color: transparent;
      background-size: 20px 44px;
    }
    .swiper-button-prev {
      width: 50px;
      height: 50px;
      background: url('../../assets/images/mb/left-icon.png') no-repeat;
      background-size: 50px 50px;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
    .swiper-button-next {
      width: 50px;
      height: 50px;
      background: url('../../assets/images/mb/right-icon.png') no-repeat;
      background-size: 50px 50px;
      opacity: 0.8;
      &:hover {
        opacity: 1;
      }
    }
    .swiper-button-next.swiper-button-disabled, .swiper-button-prev.swiper-button-disabled {
      visibility: hidden;
    }
    .item {
      position: relative;
      width: 300px;
      height: 300px;
      overflow: hidden;
      cursor:pointer;
      // background:linear-gradient(60deg,rgb(241, 165, 0) 0%,rgb(252, 206, 1) 50%,rgb(241, 165, 0) 100%);
      // &:hover {
      //   background:linear-gradient(60deg,rgb(241, 76, 0) 0%,rgb(252, 206, 1) 50%,rgb(241, 76, 0) 100%);
      // }
      .title {
        position: absolute;
        left: 0;
        top: 10px;
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color:#fff;
        font-size:22px;
        z-index:9;
        box-sizing: border-box;
        padding: 0 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .nomal {
        display: block;
        width: 300px;
        height: 300px;
        object-fit: contain;
        transition: all .3s;
      }
      .active {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 56px;
        line-height: 56px;
        text-align: center;
        color:white;
        background-color: #ccc;
        display: none;
      }
      .bottom {
        position: absolute;
        width: 300px;
        height: 56px;
        position: absolute;
        left: 0;
        bottom: 0;
        line-height: 56px;
        font-size:18px;
        color:white;
        text-align: center;
        background-color: rgba(0,0,0,.5);
        img {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          z-index:-1;
        }
      }
      &:hover {
        .title {
          color: #ffff7b;
        }
        .nomal {
          transform: scale(1.1);
        }
        .bottom {
          color: #fde9aa;
          background-color: rgba(0,0,0,.6);
        }
      }
    }

    
  }
  ul {
    width: 1200px;
    margin: 0 auto;
    margin-top: 570px;
    background: #111;
    overflow: hidden;
    clear: both;
    -webkit-box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
    display: flex;
    li {
      width: 300px;
      height: 300px;
      position: relative;
      img{
          width: 100%;
        }
      .btn {
        position: absolute;
        width: 100%;
        height: 56px;
        left: 0;
        bottom: 0;
        text-align: center;
        line-height: 56px;
        -webkit-transition: all 0.15s;
        transition: all 0.15s;
        line-height: 52px;
        font-size: 16px;
        color: #fff;
        -webkit-box-shadow: 1px 1px 1px #000;
        box-shadow: 1px 1px 1px #000;
        
      }
      .btn:hover{
        background: rgba(0,0,0,.12);
        -webkit-box-shadow: 0 0 5px rgba(0,0,0,.12);
        box-shadow: 0 0 5px rgba(0,0,0,.12);
      }
    }
  }
}
</style>
